// extracted by mini-css-extract-plugin
export default {"goodsCard":"WebGoods_goodsCard__UNCRC","goodsCardTitle":"WebGoods_goodsCardTitle__PC9z2"};